import { render } from "./WhatsAppWidget.vue?vue&type=template&id=34c4d766"
import script from "./WhatsAppWidget.vue?vue&type=script&lang=js"
export * from "./WhatsAppWidget.vue?vue&type=script&lang=js"

import "./WhatsAppWidget.vue?vue&type=style&index=0&id=34c4d766&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__